import { Navigate } from 'react-router-dom';
import { hasDomain, isBootstrapAdmin } from '../../utils/authStorage';

/**
 * DomainRoute — renders children only if the authenticated user has access
 * to the specified domain.
 *
 * Bootstrap admin (domain=public) is redirected to tenant management.
 */
export function DomainRoute({ domain, children, fallback }) {
  if (isBootstrapAdmin()) {
    return <Navigate to="/tenant-management" replace />;
  }


  if (!hasDomain(domain)) {
    // Redirect to the first available domain's landing page
    if (fallback) return <Navigate to={fallback} replace />;
    if (hasDomain('construction')) return <Navigate to="/construction/projects" replace />;
    if (hasDomain('surveillance')) return <Navigate to="/dashboard" replace />;
    return <Navigate to="/login" replace />;
  }

  return children;
}
